import SectionHeader from "../components/SectionHeader"
import AboutPanel from "../components/AboutPanel"
import Co from "../components/Co"

export default function About(){
    return (
        <div className = "flex flex-col justify-center min-h-screen py-16">

            <SectionHeader title = "About me" />

            <div className = "flex flex-row w-3/4 m-auto py-4 text-3xl">

                <p>Hi! I'm Amar, a junior at the University of Maryland studying Computer Science with a
                    Statistics minor, graduating in May 2028. Most of what I do outside of class comes back
                    to building something.
                </p>

            </div>

            <AboutPanel art = "terminal" color = "#4ade80" delay = {0}>
                <p>That building has mostly taken the shape of software engineering, heavy on the cloud side
                    with a good amount of AI/ML mixed in, and lately I've been pushing myself toward
                    infrastructure and systems design. What keeps me going through all of it is the learning.
                    I'll pick up a problem because it's hard and teaches me something long before I'll pick it
                    up for how it looks on paper or because it uses whatever's new, though new tech does get me
                    excited for that same reason: it shows up with a fresh set of problems nobody has solved
                    cleanly yet. Honestly, I just like learning, and I'll work on almost anything that lets me
                    do it.
                </p>
            </AboutPanel>

            <AboutPanel art = "briefcase" color = "#d9a441" flip delay = {-2.3}>

                <div className = "about-group">

                    <p className = "about-lead">So far, that's taken me across industry and research:</p>

                    <ul className = "about-list">
                        <li><Co color = "#ff9900">Amazon Web Services</Co>, where I'm an SDE intern on the Redshift platform out in Redmond</li>
                        <li><Co color = "#3d8fc9">Capital One</Co>, where I spent this past summer as a software engineering intern</li>
                        <li><Co color = "#ffd200">UMIACS</Co>, doing machine learning research in Dr. Furong Huang's lab on grasp ranking for robotics</li>
                        <li><Co color = "#e21833">TerpLabs</Co>, which I co-founded to give other students a place to build with real runway</li>
                    </ul>

                </div>

                <div className = "about-group">

                    <p className = "about-lead">And outside of those, I'm building my own things:</p>

                    <ul className = "about-list">
                        <li>An IEX matching engine simulation in C++, alongside a few other systems projects</li>
                        <li>Timber, a multi-track audio and video editor I want to turn into an open-source Songsterr and a one-stop utility for everything I need out of one</li>
                    </ul>

                </div>

            </AboutPanel>

            <AboutPanel art = "drums" color = "#ffd200" delay = {-4.6}>
                <p>That habit doesn't really switch off. Away from a desk I'm usually on the drums or in the
                    gym, and back at one I'm somehow still building anyway, whether that's messing around with
                    whatever AI tooling just came out or throwing myself at puzzles and system design problems
                    to find out what I don't know yet.
                </p>
            </AboutPanel>

        </div>
    )
}
